// extracted by mini-css-extract-plugin
export default {"root":"Mark_root__pN1GR","label":"Mark_label__wcPo6","tips":"Mark_tips__s6rQ3","text":"Mark_text__0Y1rE","saveBtn":"Mark_saveBtn__KRVqr"};